export default __webpack_public_path__ + "static/media/virus1.926be9d0.png";